import React from 'react';
import { Checkbox as ChakraCheckbox } from '@chakra-ui/react';
import { OptionLabel } from '../OptionLabel';
import { CoreCheckboxProps } from './types';

export const Checkbox = React.forwardRef<HTMLDivElement, CoreCheckboxProps>(
  ({ children, label, helpText, tooltip, ...rest }: CoreCheckboxProps, ref: React.ForwardedRef<HTMLDivElement>) => {
    return (
      <ChakraCheckbox ref={ref} {...rest}>
        <OptionLabel label={label} helpText={helpText} tooltip={tooltip}>
          {children}
        </OptionLabel>
      </ChakraCheckbox>
    );
  }
);

Checkbox.displayName = 'checkbox';
